export default __webpack_public_path__ + "assets/pdf/indigeNFT-roadmap2022.fd9974e7.pdf";